<script lang="ts">
    import { get_current_component, onMount } from 'svelte/internal'
    import { Person } from '../../modules/eventsApi/persons/person'
    import { Card } from '../../modules/pipelineApi/pipeline/cards/card'
    import type { CardCreateDto } from '../../modules/pipelineApi/pipeline/cards/cards-create.dto'
    import type { CardUpdateDto } from '../../modules/pipelineApi/pipeline/cards/cards-update.dto'
    import { CardsRepository } from '../../modules/pipelineApi/pipeline/cards/cards.repository'
    import { CardsService } from '../../modules/pipelineApi/pipeline/cards/cards.service'
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    dayjs.extend(utc)
    import { createEventDispatcher } from 'svelte'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import InlineSelect from '../_common/inline-select.svelte'
    import { User } from '../../modules/usersApi/users/user'
    import Fa from 'svelte-fa'
    import { faTimes } from '@fortawesome/free-solid-svg-icons'
    import Zinput from '../_common/z/zinput.svelte'
    import Zframe from '../_common/z/zframe.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerRow from '../_common/z/z-container-row.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    const dispatch = createEventDispatcher()

    export let listId: string
    export let boardId: string
    export let cardId: string
    export let userId: string

    let user: User = new User()
    user.userId = userId
    let person: Person = null
    let show: boolean = false
    const me = get_current_component()
    const cardR: CardsRepository = new CardsRepository('boards/' + boardId + '/lists/' + listId + '/cards')

    const cardS: CardsService = new CardsService(cardR)
    let card: Card = null
    let scheduledAt = null
    let text: string = ''

    async function loadEntity(id: string) {
        try {
            show = true
            card = new Card()
            card = await cardS.getOne(id)
            text = card.text
            scheduledAt = card.scheduledAt ? dayjs(card.scheduledAt).utc().format('YYYY-MM-DD') : null
            person = new Person()
            person.personId = card.personId
            person = person
            user = new User()
            user.userId = card.userId
            console.log('card', card)
            card = card
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function saveEntity() {
        if (card.listId) {
            updateEntity()
        } else {
            createEntity()
        }
    }

    function validateDto(dto) {
        if (!dto.userId) {
            evaluateError('Informe o proprietário do cartão')
            return false
        }

        return true
    }

    async function createEntity() {
        try {
            if (!card.title) {
                window.error('Informe o conteúdo do cartão')
                return
            }
            show = true
            let title = card.title
            if (!title && person?.personId) {
                title = person.name + (person.phone ? ' (' + person.phone + ')' : '')
            }
            const dto: CardCreateDto = {
                userId: user.userId,
                personId: person?.personId || undefined,
                title: title,
                scheduledAt: scheduledAt,
                text: text,
            }
            if (!validateDto(dto)) return false
            card = await cardS.create(dto)
            emitChange(card)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function updateEntity() {
        try {
            if (!card.title) {
                window.error('Informe o conteúdo do cartão')
                return
            }

            show = true
            const dto: CardUpdateDto = {
                userId: user.userId,
                title: card.title,
                text: text,
                status: card.status,
                personId: person?.personId || undefined,
                scheduledAt: scheduledAt ? new Date(scheduledAt) : null,
            }
            card = await cardS.update(card.cardId, dto)
            emitChange(card)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    async function removeEntity() {
        if (!confirm('Deseja mesmo excluir este registro?')) {
            return
        }
        try {
            show = true
            await cardS.remove(card.cardId)
            emitChange(card)
        } catch (error) {
            evaluateError(error)
        } finally {
            show = false
        }
    }

    function evaluateError(error) {
        window.error(error)
    }

    function emitChange(card: Card) {
        dispatch('change', { detail: card })
    }

    const statusList = [
        { label: 'Em andamento', value: 100 },
        { label: 'Congelado', value: 70 },
        { label: 'Cancelado', value: 80 },
        { label: 'Concluído', value: 90 },
    ]

    let loaded = false
    onMount(async () => {
        if (cardId) {
            await loadEntity(cardId)
        } else {
            card = new Card()
            card.status = 100
        }
        loaded = true
    })

    function clearScheduler() {
        scheduledAt = null
    }
</script>

{#if loaded}
    <div class="grid-act">
        {#if card.cardId}
            <button class="btn btn-warning" on:click={removeEntity}>Excluir</button>
        {/if}
        <div class="spacer" />
        {#if user?.userId === window.store.token?.userId || window.store.token.permissions.pipeline.pipeline.others.write}
            <button class="btn btn-primary" on:click={saveEntity}>Salvar</button>
        {/if}
    </div>

    <Zframe class="m-3">
        <ZContainer>
            <Zinput label="Título" type="textarea" bind:value={card.title}></Zinput>
            <ZContainerRow>
                <ZContainerCol>
                    <InlineSelect options={statusList} bind:value={card.status} />
                </ZContainerCol>
            </ZContainerRow>
        </ZContainer>
    </Zframe>
    <Zframe class="m-3 mt-0">
        <ZContainer>
            <Zinput label="Adicione mais detalhes" type="textarea" bind:value={text}></Zinput>
            <ZContainerRow>
                <ZContainerCol>
                    <div class="input-group pe-2">
                        <label for="" class="input-group-text">Lembrete</label>
                        <input class="form-control" bind:value={scheduledAt} type="date" />
                        <button class="btn btn-secondary" on:click={clearScheduler}><Fa icon={faTimes} /></button>
                    </div>
                </ZContainerCol>
                <ZContainerCol>
                    <ZentitySelect fonte="usuario" label="Proprietário" bind:value={user} />
                </ZContainerCol>
            </ZContainerRow>
            <ZContainerRow>
                <ZContainerCol>
                    <ZentitySelect fonte="pessoa" label="Pessoa vinculada" disabled={!!person?.personId} bind:value={person} />
                </ZContainerCol>
            </ZContainerRow>
        </ZContainer>
    </Zframe>
{/if}
<LoadSpinner {show} />

<style>
    .row {
        padding: 0px 16px;
    }
</style>
